// Catálogo de pantallas de la app: patrón de ruta (el mismo que en App.jsx) y
// nombre legible para el panel "Uso de la app". El registro de uso guarda el
// PATRÓN (p.ej. /supervisora/carrito/:id_piso), nunca la URL con ids concretos.
// Si se añade una ruta nueva en App.jsx, añadirla aquí; si no, se registra con
// su propia ruta como nombre.

export const PANTALLAS = {
  "/admin": "Menú admin",
  "/admin/alumnos": "Gestión de alumnos",
  "/admin/alumnos/historial": "Historial de alumnos",
  "/admin/analisis-alumnos": "Análisis de alumnos",
  "/admin/analisis-asistentas": "Análisis de asistentas",
  "/admin/analisis-datos": "Análisis de compras",
  "/admin/analisis-pisos": "Estado de pisos",
  "/admin/analisis-supervisoras": "Análisis de supervisoras",
  "/admin/configuracion-servicios": "Configuración de servicios",
  "/admin/configuracion-servicios/incidencias-opciones": "Config. incidencias",
  "/admin/configuracion-servicios/opciones-extras": "Config. extras",
  "/admin/configuracion-servicios/opciones-no-hecho": "Config. no hecho",
  "/admin/configuracion-servicios/reporte-opciones": "Config. reporte",
  "/admin/configuracion-servicios/supervisoras-media": "Config. supervisoras media",
  "/admin/descargas": "Panel de descargas",
  "/admin/encargadas/:adminUser": "Mis supervisoras",
  "/admin/encargados-supervisoras": "Encargados de supervisoras",
  "/admin/gastos": "Gastos (solo lectura)",
  "/admin/organizarServicio": "Organizar servicio (admin)",
  "/admin/pisos": "Gestión de pisos",
  "/admin/pisos/historial": "Historial de pisos",
  "/admin/productos": "Gestión de productos",
  "/admin/reporte-asistentas": "Reporte de asistentas (admin)",
  "/admin/reporte-supervisoras": "Reporte de supervisoras (admin)",
  "/admin/reportes-diarios": "Reportes diarios",
  "/admin/seguimiento-compradores": "Seguimiento compradores",
  "/admin/seguimiento-repartidores": "Seguimiento repartidores",
  "/admin/seguimiento-ruta-supervisora": "Ver ruta supervisora",
  "/admin/seguimientoServicios": "Seguimiento servicios",
  "/admin/usuarios": "Gestión de usuarios",
  "/admin/usuarios/historial": "Historial de usuarios",
  "/admin/verCompras": "Ver compras (admin)",
  "/admin/uso-app": "Uso de la app",
  "/alumnos/editar/:id": "Editar alumno",
  "/alumnos/nuevo": "Nuevo alumno",
  "/asistenta": "Inicio asistenta",
  "/asistenta/piso": "Ejecución del piso",
  "/asistenta/reporteDiario": "Reporte diario (asistenta)",
  "/asistenta/verReporteDiario": "Ver reporte diario",
  "/comprador": "Inicio comprador",
  "/comprador/detalleCompra": "Detalle de compra",
  "/comprador/ordenarCompra": "Ordenar compra",
  "/comprador/verCompras": "Ver compras (comprador)",
  "/contabilidad": "Contabilidad",
  "/pisos/editar/:id": "Editar piso",
  "/pisos/nuevo": "Nuevo piso",
  "/productos/editar/:id": "Editar producto",
  "/productos/nuevo": "Nuevo producto",
  "/repartidor": "Repartos",
  "/superadmin": "Menú superadmin",
  "/superadmin/compras": "Superadmin · compras",
  "/superadmin/historial": "Historial general",
  "/superadmin/sustituciones": "Sustituciones de asistentas",
  "/superadmin/notificaciones": "Notificaciones (dispositivos)",
  "/admin/calendario-limpiezas": "Calendario de limpiezas",
  "/supervisora/calendario-limpiezas": "Calendario de limpiezas",
  "/supervisora/ruta": "Mi Ruta",
  "/admin/ruta-supervisora": "Ruta de supervisora",
  "/supervisora/organizar-ruta-3": "Organizar Ruta 3",
  "/admin/organizar-ruta-3": "Organización Ruta 3",
  "/admin/sustituciones": "Sustituciones de asistentas",
  "/superadmin/importar": "Gestionar datos",
  "/superadmin/servicios": "Superadmin · servicios",
  "/superadmin/uso-app": "Uso de la app",
  "/supervisora": "Inicio supervisora",
  "/supervisora/SeguimientoDelDia": "Seguimiento del día",
  "/supervisora/analisis-alumnos": "Análisis alumnos (supervisora)",
  "/supervisora/analisis-asistentas": "Análisis asistentas (supervisora)",
  "/supervisora/analisis-pisos": "Análisis pisos (supervisora)",
  "/supervisora/carrito/:id_piso": "Carrito",
  "/supervisora/compras": "Compras (supervisora)",
  "/supervisora/crearCompras/:id_piso": "Crear compra",
  "/supervisora/modificarVerCompras": "Modificar compras",
  "/supervisora/organizarServicio": "Organizar servicio",
  "/supervisora/pisoCrearCompras": "Elegir piso (compras)",
  "/supervisora/pisoOrganizarServicios": "Elegir piso (servicios)",
  "/supervisora/prestamos": "Préstamos y gastos",
  "/supervisora/reporte-asistentas": "Reporte de asistentas",
  "/supervisora/reporte-diario": "Reporte diario (lista)",
  "/supervisora/reporte-supervisoras": "Reporte de supervisoras",
  "/supervisora/reporteDiario": "Reporte diario (supervisora)",
  "/supervisora/servicios": "Servicios (supervisora)",
  "/supervisora/verDatosCompras": "Datos de compras",
  "/usuarios/editar/:user": "Editar usuario",
  "/usuarios/nuevo": "Nuevo usuario",
};

// Rutas que no son uso real de la app
const EXCLUIDAS = new Set(["/login", "/unauthorized", "/"]);

const COMPILADAS = Object.keys(PANTALLAS).map((patron) => ({
  patron,
  re: new RegExp("^" + patron.replace(/:[^/]+/g, "[^/]+") + "/?$"),
}));

// Devuelve el patrón de la ruta actual, o null si no hay que registrarla.
export function patronDeRuta(pathname) {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  if (EXCLUIDAS.has(p)) return null;
  const hit = COMPILADAS.find((c) => c.re.test(p));
  if (hit) return hit.patron;
  // ruta no catalogada: se guarda sustituyendo números por :id
  return p.replace(/\/\d+(?=\/|$)/g, "/:id").slice(0, 120);
}

export const nombrePantalla = (patron) => PANTALLAS[patron] || patron;
